import { get } from "lodash"
import { createSelector } from "reselect"
import { getSelectedDate as getPortfolioSelectedDate } from "selectors/dates"
import { getEarliestDate, getLatestDate } from "modules/portfolio-root/selectors/dates"
import { getPeriod } from "modules/portfolio-root/selectors/portfolios"
import { getSelectedDate as getExperimentSelectedDate } from "modules/edit-experiment/selectors/dates"
import { clampDate } from "helpers/dates"

const EMPTY_ARRAY = []

const getPortfolioId = (state) => get(state, "global.selected.portfolio")
const getAccount = (state) => get(state, "global.selected.account")
const getOptimizationDate = (state) => get(state, "modules.optimization.optimizationDate")
export const getSelectedExperiment = (state) => get(state, "modules.optimization.experiment")
export const getForecasts = (state) => get(state, "global.data.forecasts.data.forecasts", EMPTY_ARRAY)

export const getRebalanceUrl = createSelector(
  [getPortfolioId, getAccount],
  (portfolioId, account) => `/${account}/p/${portfolioId}/rebalance/simulator`,
)

export const getOptimizeDate = createSelector(
  [getOptimizationDate, getPeriod, getPortfolioSelectedDate, getEarliestDate, getLatestDate, getExperimentSelectedDate],
  (optimizationDate, period, portfolioSelectedDate, earliestDate, latestDate, experimentSelectedDate) => {
    if (optimizationDate?.selectedDate) {
      return optimizationDate.selectedDate
    }

    if (experimentSelectedDate && experimentSelectedDate <= latestDate && experimentSelectedDate >= earliestDate) {
      return experimentSelectedDate
    }

    if (portfolioSelectedDate) {
      return portfolioSelectedDate
    }

    if (period.endDate) {
      return clampDate(period.endDate, earliestDate, latestDate)
    }

    return latestDate
  })
